import { useEffect, useState } from "react";
import { fetchUxBuildInfo, type UxBuildInfo } from "@/services/uxBuildInfo";

export const useUxBuildInfo = (): UxBuildInfo | null => {
  const [data, setData] = useState<UxBuildInfo | null>(null);

  useEffect(() => {
    let cancelled = false;
    void fetchUxBuildInfo().then((info) => {
      if (!cancelled) setData(info);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return data;
};
